import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.bmc.discovery');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-bmc-discovery',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/.kiera-build/src/app/page.kiera.bmc.discovery/view.scss */
:host {
  display: block;
  height: 100%;
}

button,
input,
select {
  font-family: inherit;
}

table th,
table td {
  white-space: nowrap;
}`],
})
export class PageKieraBmcDiscoveryComponent implements OnInit, OnDestroy {
    public scanForm: any = { ip: '', credentialId: '' };
    public credentials: any[] = [];
    public selectedCredential: any = null;
    public scanResults: any[] = [];
    public selectedIds: any[] = [];
    public registeredNodes: any[] = [];

    public isScanning: boolean = false;
    public isRefreshing: boolean = false;
    public isExecuting: boolean = false;
    public feedback: string = '';
    public feedbackType: string = 'info';
    public commandResults: any[] = [];

    public selectedBoot: string = '';
    public selectedPower: string = '';
    public bootOptions: any[] = [
        { value: 'Get boot device', label: 'Get Current Boot Device', group: 'Query' },
        { value: 'Boot PXE-Auto', label: 'PXE Boot (Auto)', group: 'Set Boot Device' },
        { value: 'Boot PXE-UEFI', label: 'PXE Boot (UEFI)', group: 'Set Boot Device' },
        { value: 'Boot PXE-Legacy', label: 'PXE Boot (Legacy)', group: 'Set Boot Device' },
        { value: 'Boot None-UEFI', label: 'Local Disk Boot (UEFI)', group: 'Set Boot Device' },
        { value: 'Boot None-Legacy', label: 'Local Disk Boot (Legacy)', group: 'Set Boot Device' },
        { value: 'BIOS-UEFI', label: 'Enter BIOS Setup (UEFI)', group: 'Set Boot Device' },
        { value: 'BIOS-Legacy', label: 'Enter BIOS Setup (Legacy)', group: 'Set Boot Device' },
    ];
    public powerOptions: any[] = [
        { value: 'Get power', label: 'Get Current Power Status' },
        { value: 'Power On', label: 'Power On' },
        { value: 'Force Power Off', label: 'Power Off' },
        { value: 'Soft Power Off', label: 'Soft Power Off' },
        { value: 'Cold Reset', label: 'Power Cycle' },
        { value: 'Warm Reset', label: 'Power Reset' },
    ];

    public currentPage: number = 1;
    public pageSize: number = 20;
    public pageSizeOptions: number[] = [10, 20, 50];

    private readonly credentialMessageType: string = 'kiera:bmc-credential-saved';

    private readonly onCredentialWindowFocus = async () => {
        await this.loadCredentials();
        await this.service.render();
    };

    private readonly onCredentialMessage = async (event: MessageEvent) => {
        if (event.origin !== window.location.origin || event.data?.type !== this.credentialMessageType) return;
        const credential = event.data?.credential;
        if (!credential || credential.id === undefined || credential.id === null) return;

        await this.loadCredentials();
        this.scanForm.credentialId = credential.id;
        this.syncSelectedCredential();
        this.feedback = credential.name + ' Credential Profile을 선택했습니다.';
        this.feedbackType = 'success';
        await this.service.render();
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        window.addEventListener('focus', this.onCredentialWindowFocus);
        window.addEventListener('message', this.onCredentialMessage);
        await this.loadCredentials();
        await this.loadResults();
        await this.service.render();
    }

    public ngOnDestroy() {
        window.removeEventListener('focus', this.onCredentialWindowFocus);
        window.removeEventListener('message', this.onCredentialMessage);
    }

    private async loadCredentials() {
        const previousId = this.scanForm.credentialId;
        const { code, data } = await wiz.call('credentials');
        this.credentials = code === 200 && Array.isArray(data?.rows) ? data.rows : [];

        const previous = this.credentials.find((item: any) => String(item.id) === String(previousId));
        const next = previous || this.credentials[0] || null;
        this.scanForm.credentialId = next?.id ?? '';
        this.syncSelectedCredential();
    }

    private syncSelectedCredential() {
        this.selectedCredential = this.credentials.find((item: any) =>
            String(item.id) === String(this.scanForm.credentialId)
        ) || null;
    }

    public async onCredentialChange() {
        this.syncSelectedCredential();
        await this.service.render();
    }

    public async openNewCredential() {
        const popup = window.open(
            '/kiera/bmc-credentials?mode=create&source=bmc-discovery',
            'bmc_credential_create',
            'width=1180,height=820,menubar=no,toolbar=no,location=no,status=no,resizable=yes,scrollbars=yes'
        );
        if (popup) {
            popup.focus();
            return;
        }
        this.feedback = '새 Credential 창을 열 수 없습니다. 브라우저의 팝업 허용 설정을 확인하세요.';
        this.feedbackType = 'error';
        await this.service.render();
    }

    public canExecute(): boolean {
        return this.service.auth.can('bmc_discovery', 'execute');
    }

    public canRemove(): boolean {
        return this.service.auth.can('bmc_discovery', 'remove');
    }

    public statusLabel(): string {
        if (this.isScanning) return 'Discovering...';
        if (this.isExecuting) return 'Executing command...';
        if (this.isRefreshing) return 'Refreshing...';
        return 'Ready';
    }

    public protocolLabel(credential: any): string {
        if (!credential) return '-';
        return credential.protocol === 'Redfish' ? 'Redfish (HTTPS)' : 'IPMI';
    }

    public tlsLabel(credential: any): string {
        if (!credential || credential.protocol !== 'Redfish') return '-';
        return credential.tls === false ? '사용 안 함' : '사용';
    }

    public async runDiscovery() {
        if (!this.canExecute()) {
            await this.showError('BMC Discovery 실행 권한이 없습니다.');
            return;
        }
        if (!String(this.scanForm.ip || '').trim()) {
            await this.showError('검색할 IP Address를 입력하세요.');
            return;
        }
        if (!this.selectedCredential) {
            await this.showError('BMC Credential Profile을 선택하거나 새로 생성하세요.');
            return;
        }
        const credential = this.selectedCredential;
        if (!credential.hasPassword) {
            await this.showError('선택한 Credential Profile에 Password가 없습니다. BMC Credentials에서 Password를 저장하세요.');
            return;
        }

        this.isScanning = true;
        this.feedback = '입력한 네트워크에서 BMC 장비를 검색하고 있습니다.';
        this.feedbackType = 'info';
        await this.service.render();

        const { code, data } = await wiz.call('scan', {
            ip: String(this.scanForm.ip).trim(),
            credential_id: credential.id,
        });

        if (code === 200) {
            this.registeredNodes = data.registered || [];
            const found = Number(data.found_count ?? data.results?.length ?? 0);
            this.feedback = 'BMC Discovery가 완료되었습니다. ' + found + '대의 장비를 확인했습니다.';
            if (this.registeredNodes.length > 0) {
                this.feedback += ' 기존 등록 노드 ' + this.registeredNodes.length + '대는 결과에서 제외했습니다.';
            }
            this.feedbackType = 'success';
            await this.loadResults(false);
        } else {
            this.feedback = data?.message || 'BMC Discovery 실행에 실패했습니다.';
            this.feedbackType = 'error';
        }
        this.isScanning = false;
        await this.service.render();
    }

    public async loadResults(render: boolean = true) {
        const selected = new Set(this.selectedIds.map((id: any) => String(id)));
        const { code, data } = await wiz.call('list');
        if (code === 200) {
            this.scanResults = (data.rows || []).map((row: any) => ({ ...row }));
            this.selectedIds = this.scanResults
                .filter((row: any) => selected.has(String(row.id)))
                .map((row: any) => row.id);
            const maxPage = Math.max(1, this.totalPages());
            if (this.currentPage > maxPage) this.currentPage = maxPage;
        }
        if (render) await this.service.render();
    }

    public async refreshResults() {
        this.isRefreshing = true;
        await this.service.render();
        await this.loadResults(false);
        this.isRefreshing = false;
        this.feedback = '검색 결과를 최신 상태로 갱신했습니다.';
        this.feedbackType = 'success';
        await this.service.render();
    }

    public isSelected(id: any): boolean {
        return this.selectedIds.some((selectedId: any) => String(selectedId) === String(id));
    }

    public async toggleSelected(id: any) {
        if (this.isSelected(id)) {
            this.selectedIds = this.selectedIds.filter((selectedId: any) => String(selectedId) !== String(id));
        } else {
            this.selectedIds = this.selectedIds.concat([id]);
        }
        await this.service.render();
    }

    public allPageSelected(): boolean {
        const rows = this.pagedResults();
        return rows.length > 0 && rows.every((row: any) => this.isSelected(row.id));
    }

    public async toggleAllPage() {
        const pageIds = this.pagedResults().map((row: any) => row.id);
        if (this.allPageSelected()) {
            this.selectedIds = this.selectedIds.filter((id: any) =>
                !pageIds.some((pageId: any) => String(pageId) === String(id))
            );
        } else {
            const keys = new Set(this.selectedIds.map((id: any) => String(id)));
            pageIds.forEach((id: any) => keys.add(String(id)));
            this.selectedIds = this.scanResults
                .filter((row: any) => keys.has(String(row.id)))
                .map((row: any) => row.id);
        }
        await this.service.render();
    }

    public selectedRows(): any[] {
        return this.scanResults.filter((row: any) => this.isSelected(row.id));
    }

    public async deleteSelected() {
        if (!this.canRemove()) {
            await this.showError('검색 결과 삭제 권한이 없습니다.');
            return;
        }
        if (this.selectedIds.length === 0) {
            await this.showError('삭제할 장비를 선택하세요.');
            return;
        }
        const confirmed = await this.service.modal.show({
            title: '선택 항목 삭제',
            message: '선택한 ' + this.selectedIds.length + '개 BMC 검색 결과를 삭제하시겠습니까?',
            action: '삭제',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error',
        });
        if (!confirmed) return;

        const { code, data } = await wiz.call('delete_selected', { ids: JSON.stringify(this.selectedIds) });
        if (code !== 200) {
            await this.showError(data?.message || '선택 항목 삭제에 실패했습니다.');
            return;
        }
        this.selectedIds = [];
        await this.loadResults(false);
        this.feedback = '선택한 검색 결과를 삭제했습니다.';
        this.feedbackType = 'success';
        await this.service.render();
    }

    public async executeCommand(type: string) {
        if (!this.canExecute()) {
            await this.showError('BMC 명령 실행 권한이 없습니다.');
            return;
        }
        const rows = this.selectedRows();
        if (rows.length === 0) {
            await this.showError('명령을 실행할 BMC 장비를 선택하세요.');
            return;
        }
        const command = type === 'boot' ? this.selectedBoot : this.selectedPower;
        if (!command) {
            await this.showError(type === 'boot' ? 'Boot Device 명령을 선택하세요.' : 'Power Control 명령을 선택하세요.');
            return;
        }
        const unavailableRows = rows.filter((row: any) =>
            !Number(row.bmc_credential_id)
            || !row.bmc_credential_name
            || row.bmc_credential_active === false
            || !row.has_bmc_password
        );
        if (unavailableRows.length > 0) {
            const hosts = unavailableRows.slice(0, 5).map((row: any) => row.host).join(', ');
            await this.showError(
                '저장된 Credential Profile을 사용할 수 없는 검색 결과가 포함되어 있습니다: '
                + hosts
                + (unavailableRows.length > 5 ? ' 외 ' + (unavailableRows.length - 5) + '대' : '')
                + '. 해당 장비를 유효한 Profile로 다시 탐색하세요.'
            );
            return;
        }

        this.isExecuting = true;
        this.commandResults = [];
        this.feedback = rows.length + '대 장비에 각 검색 결과의 Credential Profile로 원격 명령을 실행하고 있습니다.';
        this.feedbackType = 'info';
        await this.service.render();

        const { code, data } = await wiz.call('execute_command', {
            ids: JSON.stringify(rows.map((row: any) => row.id)),
            command_type: type,
            command,
        });

        if (code === 200) {
            const results = data.results || [];
            this.commandResults = results;
            const successCount = results.filter((item: any) => item.success).length;
            this.feedback = '명령 실행 완료: 성공 ' + successCount + '대 / 전체 ' + results.length + '대';
            const firstFailure = results.find((item: any) => !item.success);
            if (firstFailure) {
                this.feedback += ' · ' + firstFailure.host + ': ' + String(firstFailure.data || '명령 실행 실패').slice(0, 180);
            }
            this.feedbackType = successCount === results.length ? 'success' : 'warning';
            await this.loadResults(false);
        } else {
            this.commandResults = [];
            this.feedback = data?.message || 'BMC 명령 실행에 실패했습니다.';
            this.feedbackType = 'error';
        }
        this.isExecuting = false;
        await this.service.render();
    }

    public async registerSelectedNodes() {
        if (this.selectedIds.length === 0) {
            await this.showError('노드로 등록할 BMC 장비를 선택하세요.');
            return;
        }
        if (this.isExecuting) return;
        this.isExecuting = true;
        await this.service.render();
        try {
            const response = await wiz.call("register_selected", { ids: JSON.stringify(this.selectedIds) });
            if (response.code !== 200) {
                this.feedback = response.data?.message || 'Discovery registration failed';
                this.feedbackType = 'error';
            } else {
                this.feedback = (await this.service.lang.translate('gap.discovery.result'))
                    .replace('{created}', String(response.data.created)).replace('{skipped}', String(response.data.skipped)).replace('{failed}', String(response.data.failed));
                const failure = (response.data.results || []).find((row: any) => row.status === 'failed');
                if (failure) this.feedback += ' · ' + failure.message;
                this.feedbackType = response.data.failed ? 'warning' : 'success';
                this.selectedIds = [];
                await this.loadResults(false);
            }
        } catch (_) {
            this.feedback = await this.service.lang.translate('gap.discovery.failed');
            this.feedbackType = 'error';
        } finally {
            this.isExecuting = false;
            await this.service.render();
        }
    }

    public exportCsv() {
        const rows = this.selectedRows().length > 0 ? this.selectedRows() : this.scanResults;
        if (rows.length === 0) {
            this.feedback = '내보낼 검색 결과가 없습니다.';
            this.feedbackType = 'warning';
            this.service.render();
            return;
        }
        const headers = ['BMC IP', 'BMC MAC', 'CREDENTIAL PROFILE', 'POWER', 'BOOT DEVICE', 'BOOT MODE', 'SCANNED'];
        const values = rows.map((row: any) => [
            row.host || '',
            row.mac_address || '',
            row.bmc_credential_name || '',
            this.powerLabel(row.power_status),
            this.bootDeviceLabel(row.boot_device),
            row.boot_mode || '',
            row.scan_date || '',
        ]);
        const escape = (value: any) => '"' + String(value ?? '').replace(/"/g, '""') + '"';
        const csv = [headers].concat(values).map((row: any[]) => row.map(escape).join(',')).join('\r\n');
        const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = 'bmc-discovery-' + this.dateStamp() + '.csv';
        anchor.click();
        URL.revokeObjectURL(url);
    }

    public async showDetail(row: any) {
        const message = [
            'BMC IP: ' + (row.host || '-'),
            'BMC MAC: ' + (row.mac_address || '-'),
            'Credential Profile: ' + (row.bmc_credential_name || '-'),
            'Boot Device: ' + this.bootDeviceLabel(row.boot_device),
            'Boot Mode: ' + (row.boot_mode || '-'),
            'Power Status: ' + this.powerLabel(row.power_status),
            'Last Scan Time: ' + (row.scan_date || '-'),
        ].join('\n');
        await this.service.modal.show({
            title: 'BMC 상세 정보',
            message,
            action: '확인',
            cancel: false,
            status: 'success',
            actionBtn: 'success',
        });
    }

    public powerLabel(value: string): string {
        const normalized = String(value || '').toLowerCase();
        if (normalized === 'on') return 'On';
        if (normalized === 'off') return 'Off';
        return value || '-';
    }

    public bootDeviceLabel(value: string): string {
        const normalized = String(value || '').toLowerCase();
        if (normalized.indexOf('pxe') >= 0) return 'PXE';
        if (normalized.indexOf('bios') >= 0) return 'BIOS Setup';
        if (normalized.indexOf('none') >= 0 || normalized.indexOf('disk') >= 0 || normalized.indexOf('hdd') >= 0) return 'Local Disk';
        return value || '-';
    }

    public totalPages(): number {
        return Math.max(1, Math.ceil(this.scanResults.length / this.pageSize));
    }

    public pagedResults(): any[] {
        const start = (this.currentPage - 1) * this.pageSize;
        return this.scanResults.slice(start, start + this.pageSize);
    }

    public pageNumbers(): number[] {
        const total = this.totalPages();
        const start = Math.max(1, Math.min(this.currentPage - 2, total - 4));
        const end = Math.min(total, start + 4);
        const pages: number[] = [];
        for (let page = start; page <= end; page++) pages.push(page);
        return pages;
    }

    public async goPage(page: number) {
        if (page < 1 || page > this.totalPages()) return;
        this.currentPage = page;
        await this.service.render();
    }

    public async onPageSizeChange() {
        this.currentPage = 1;
        await this.service.render();
    }

    public visibleFrom(): number {
        if (this.scanResults.length === 0) return 0;
        return (this.currentPage - 1) * this.pageSize + 1;
    }

    public visibleTo(): number {
        return Math.min(this.currentPage * this.pageSize, this.scanResults.length);
    }

    public trackByRow(index: number, row: any) {
        return row.id;
    }

    private async showError(message: string) {
        await this.service.modal.show({
            title: '확인 필요',
            message,
            action: '확인',
            cancel: false,
            status: 'warning',
            actionBtn: 'warning',
        });
    }

    private dateStamp(): string {
        const now = new Date();
        const pad = (value: number) => String(value).padStart(2, '0');
        return now.getFullYear() + pad(now.getMonth() + 1) + pad(now.getDate())
            + '-' + pad(now.getHours()) + pad(now.getMinutes());
    }
}

export default PageKieraBmcDiscoveryComponent;
